module.exports = __webpack_public_path__ + "img/serviceGuide-center-2.8d3e829.png";